import {
  FileColumnMapping,
  ImportDataType,
} from "services/organizationPortalClient";

const importJobTypeId = "1BAD660B-43C3-4DB0-95EA-8E8C1084B064";

export const organizationUserColumnMappings: FileColumnMapping[] = [
  new FileColumnMapping({
    columnIndex: 0,
    required: true,
    importJobTypeFieldId: "ED2B5A4B-F5FF-462B-BA4F-9A7B92539AFA",
    columnName: "FirstName",
    dataType: ImportDataType.String,
    importJobTypeId: importJobTypeId,
  }),
  new FileColumnMapping({
    columnIndex: 1,
    required: true,
    importJobTypeFieldId: "789F099C-6E20-4CE0-A8F4-3D69B4199695",
    columnName: "LastName",
    dataType: ImportDataType.String,
    importJobTypeId: importJobTypeId,
  }),
  new FileColumnMapping({
    columnIndex: 2,
    required: true,
    importJobTypeFieldId: "781BA426-5335-4086-A019-4D9AE66C913E",
    columnName: "Email",
    dataType: ImportDataType.String,
    importJobTypeId: importJobTypeId,
  }),
  new FileColumnMapping({
    columnIndex: 3,
    required: true,
    importJobTypeFieldId: "F58F5B89-8733-4F03-83C0-6069EA884998",
    columnName: "AccessLevelId",
    dataType: ImportDataType.Guid,
    importJobTypeId: importJobTypeId,
  }),
];

const deactivationImportJobTypeId = "E004BD7D-6A3D-4FFC-907F-3E00FF3BA31C";

/**
 * The bulk-deactivation CSV. No AccessLevelId, because deactivation revokes whatever access the learner
 * already has; and only Email is required, because the user is matched on email alone — the name
 * columns are carried for readability in the summary email and may be blank.
 */
export const organizationUserDeactivationColumnMappings: FileColumnMapping[] = [
  new FileColumnMapping({
    columnIndex: 0,
    required: false,
    importJobTypeFieldId: "2B84CC32-5578-41D3-8C3F-DF83B2EE7A48",
    columnName: "FirstName",
    dataType: ImportDataType.String,
    importJobTypeId: deactivationImportJobTypeId,
  }),
  new FileColumnMapping({
    columnIndex: 1,
    required: false,
    importJobTypeFieldId: "E4100078-3F9D-4481-8B2D-B67D02EFFE23",
    columnName: "LastName",
    dataType: ImportDataType.String,
    importJobTypeId: deactivationImportJobTypeId,
  }),
  new FileColumnMapping({
    columnIndex: 2,
    required: true,
    importJobTypeFieldId: "CC0B1803-965C-4FD3-BB88-4EDCCE97CA7A",
    columnName: "Email",
    dataType: ImportDataType.String,
    importJobTypeId: deactivationImportJobTypeId,
  }),
];
